"use client";

import {
  getServerThemeChoice,
  getThemeChoice,
  reapplyTheme,
  subscribeThemeChoice,
  type ThemeChoice,
} from "@/lib/theme";
import { useEffect, useSyncExternalStore } from "react";

/** Le choix d'apparence enregistré, sans risque de décalage d'hydratation. */
export function useThemeChoice(): ThemeChoice {
  return useSyncExternalStore(
    subscribeThemeChoice,
    getThemeChoice,
    getServerThemeChoice,
  );
}

/**
 * Garde le thème accordé au réglage de l'appareil quand le choix est
 * « Système ». Sans ça, basculer l'OS en sombre ne se verrait qu'au prochain
 * chargement complet — le script du layout ne s'exécutant qu'une fois.
 *
 * Ne rend rien et ne porte aucun état : le thème vit sur l'attribut `data-theme`
 * de <html>, `reapplyTheme()` le recalcule depuis le choix enregistré.
 */
export function ThemeWatcher() {
  useEffect(() => {
    if (!window.matchMedia) return;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    // `reapplyTheme` relit le choix : si l'utilisateur a forcé clair ou sombre,
    // le changement d'OS est simplement sans effet.
    const onSystemChange = () => reapplyTheme();
    media.addEventListener("change", onSystemChange);
    return () => media.removeEventListener("change", onSystemChange);
  }, []);

  return null;
}
